var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Display Name",
            "error-text": _vm.showValidations
              ? _vm.validations.displayName
              : "",
            disabled: !_vm.canEditName,
          },
        },
        [
          _c("text-field", {
            model: {
              value: _vm.internalField.displayName,
              callback: function ($$v) {
                _vm.$set(_vm.internalField, "displayName", $$v)
              },
              expression: "internalField.displayName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Overridable",
            "error-text": _vm.showValidations
              ? _vm.validations.overridable
              : "",
          },
        },
        [
          _c("dropdown-field", {
            attrs: {
              source: _vm.overridableDataSource,
              "text-field": "text",
              "value-field": "value",
              placeholder: "-- Select Overridable --",
            },
            model: {
              value: _vm.overridable,
              callback: function ($$v) {
                _vm.overridable = $$v
              },
              expression: "overridable",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Category",
            "error-text": _vm.showValidations ? _vm.validations.category : "",
          },
        },
        [
          _c("multi-dropdown-field", {
            attrs: {
              placeholder: "-- Select Items --",
              source: _vm.categoriesDataSource,
              "text-field": "text",
              "value-field": "value",
              searchable: "",
              enableAddNewItem: "",
              displaySelectedItems: "",
              enableSingleClick: "",
            },
            on: {
              "add-item": function ($event) {
                return _vm.AddItem($event)
              },
            },
            model: {
              value: _vm.selectedCategoryName,
              callback: function ($$v) {
                _vm.selectedCategoryName = $$v
              },
              expression: "selectedCategoryName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          staticClass: "pb-2",
          attrs: {
            label: "Description",
            "error-text": _vm.showValidations
              ? _vm.validations.description
              : "",
            disabled: !_vm.entitledToEditDescription,
          },
        },
        [
          _c("textarea-field", {
            model: {
              value: _vm.internalField.description,
              callback: function ($$v) {
                _vm.$set(_vm.internalField, "description", $$v)
              },
              expression: "internalField.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Update")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }